import { createFileRoute } from "@tanstack/react-router"
import { InstagramConfiguration } from "modules/settings/components/integrations/instagram"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/channels/instagram")({
  component: InstagramConfiguration,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.instagram.title"),
    })
  },
})
